<script lang="ts" setup>
const {
  siteOptions: {
    footer_left_side: footerLeftSide,
    footer_center: footerCenter,
    social_media: socialMediaProfiles,
  },
} = useSiteOptions();
</script>

<template>
  <div id="site-footer">
    <div class="greyed links:link-prose py-3 paragraph-md">
      <div class="container flex flex-col items-start justify-between gap-6 md:flex-row text-left">
        <div>
          <div v-if="footerLeftSide" v-html="footerLeftSide" />
        </div>
        <div>
          <div v-if="footerCenter" v-html="footerCenter" />
        </div>
        <div class="w-full md:w-auto">
          <div v-if="socialMediaProfiles && socialMediaProfiles.length">
            <h3 class="heading-4 text-center md:text-left">
              Suivez-nous
            </h3>
            <SocialProfiles :profiles="socialMediaProfiles" />
          </div>
          <SiteFooterCopyright />
        </div>
      </div>
    </div>
    <div class="super-greyed px-4 py-1 text-sm flex justify-between">
      <div class="container">
        <SiteFooterCredits />
        <!-- <AuthLink /> -->
      </div>
    </div>
  </div>
</template>
